import { render, staticRenderFns } from "./NavSideBar.vue?vue&type=template&id=579409db&scoped=true"
import script from "./NavSideBar.vue?vue&type=script&lang=ts"
export * from "./NavSideBar.vue?vue&type=script&lang=ts"
import style0 from "./NavSideBar.vue?vue&type=style&index=0&id=579409db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579409db",
  null
  
)

export default component.exports